import React from 'react'
import { css } from 'aphrodite'

import style from '../style'

export const Button = props => {
  return (
    <span
      className={css(
        style.button.button,
        props.reversed
          ? props.active
            ? style.button.reversedActive
            : style.button.reversedInactive
          : props.active ? style.button.active : style.button.inactive
      )}
      onMouseDown={props.onMouseDown}
    >
      {props.children}
    </span>
  )
}

export default Button



// WEBPACK FOOTER //
// ./src/components/partials/Editor/partials/Button.js